import React from 'react';
import styled from 'styled-components';
import Box from './layout/Box';
import Stack from './layout/Stack';
import Heading from './content/Heading';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import checkHealthyQuery from '../graphql/queries/checkHealthyQuery';
import Loading from "../Loading";

export default function EnsureHealthyStatus({
  children,
}) {
  const { t } = useTranslation();

  const checkHealthy = useQuery(checkHealthyQuery, {
    context: { timeout: 10000 },
  });

  if (checkHealthy.loading) {
    return (
      <Loading label="Ensuring status is healthy…" />
    );
  }

  if (
    checkHealthy.error !== undefined ||
    (checkHealthy.data !== undefined && checkHealthy.data.checkHealthy.healthy === false)
  ) {
    return (
      <Container>
        <Stack space="gutter" align="center">
          <Heading level="3">
            {t('text.serviceCurrentlyNotAvailable')}
          </Heading>
        </Stack>
      </Container>
    );
  }

  return children;
}

const Container = styled(props => (
  <Box padding="gutter" {...props} />
))`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  max-width: 38rem;
  margin-right: auto;
  margin-left: auto;

  color: #fff;
`;
